const JobStatuses = {
  PENDING: "pending",
  STARTED: "started",
  COMPLETED: "completed",
  FAILED: "failed"
} as const;

const ALL = Object.values(JobStatuses);

export default { ...JobStatuses, ALL };
